import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';

@Component({
    selector: 'tpc-individual-travel-default',
    templateUrl: './individual-travel-default.component.html',
    styleUrls: ['./individual-travel-default.component.css']
})
export class IndividualTravelDefaultComponent implements OnInit, OnDestroy {
    public calculateMethod = 'flights';
    private nextSub: Subscription;

    constructor(private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
    }

    next(): void {
        this.router.navigate(['/individual/travel/' + this.calculateMethod]);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel-default/individual-travel-default.component.ts